import React from "react";
// import { getPolicyType } from "../../../utils/AppUtils";
// import {
//   PRODUCT_TYPES,
//   PRODUCT_TYPES_PER_BRANCH,
// } from "../../../utils/Constants";
import Input from "../../../components/Input";

const currencyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const AmountInForeignCurrency = (balancePoliza) => {
  return (
    <div className="w-full md:w-1/3 px-3">
      <label
        className="block tracking-wide text-gray-700 text-xs font-light mb-1"
        htmlFor="grid-last-name"
      >
        Monto Moneda Extranjera
      </label>
      <Input
        className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
        id="grid-first-name"
        type="text"
        placeholder={
          balancePoliza.moneda +
          currencyFormater.format(balancePoliza.montosMonedaOriginal.totalPagar)
        }
        disabled
      />
    </div>
  );
};

const AmountDetails = ({ isBuenViaje, balancePoliza }) => {
  return (
    <div className="flex flex-wrap -mx-3 mb-1">
      <div className={`w-full px-3 mb-2 md:mb-0 ${balancePoliza.montosMonedaOriginal ? "md:w-1/3" : "md:w-1/2"}`} >
        <label
          className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
          htmlFor="grid-first-name"
        >
          Monto total
        </label>
        <Input
          className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
          id="grid-first-name"
          type="text"
          placeholder={"RD" + currencyFormater.format(balancePoliza.totalPagar)}
          disabled
        />
      </div>
      <div className={`w-full px-3 mb-2 md:mb-0 ${balancePoliza.montosMonedaOriginal ? "md:w-1/3" : "md:w-1/2"}`} >
        <label
          className="block  tracking-wide text-gray-700 text-xs font-light mb-1"
          htmlFor="grid-first-name"
        >
          Monto mínimo
        </label>
        <Input
          className="appearance-none block w-full bg-gray-200 text-gray-700  rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white-500 text-sm"
          id="grid-first-name"
          type="text"
          placeholder={"RD" + currencyFormater.format(balancePoliza.pagoMinimo)}
          disabled
        />
      </div>
      {balancePoliza.montosMonedaOriginal && AmountInForeignCurrency(balancePoliza)}
    </div>
  );
};

export default AmountDetails;
